import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ResponsivePie } from '@nivo/pie';

import '../../assets/stylesheets/DashboardView.css';

class PieChart extends Component {
  render() {
    const { data, useCustomColors, showLegend } = this.props;
    return (
      <div className="pieContainer">
        <ResponsivePie
          data={data}
          margin={{ top: -70, right: 50, bottom: 0, left: 50 }}
          sortByValue
          colors={useCustomColors ? { datum: 'data.color' } : { scheme: 'nivo' }}
          borderColor={{ from: 'color', modifiers: [['darker', '0.1']] }}
          enableArcLinkLabels={false}
          arcLabelsSkipAngle={5}
          arcLabelsTextColor="#333333"
          animate
          motionStiffness={90}
          motionDamping={15}
          legends={
            showLegend
              ? [
                  {
                    anchor: 'bottom',
                    direction: 'row',
                    translateY: -25,
                    itemWidth: 100,
                    itemHeight: 18,
                    itemTextColor: '#999',
                    symbolSize: 18,
                    symbolShape: 'circle',
                    effects: [
                      {
                        on: 'hover',
                        style: {
                          itemTextColor: '#000'
                        }
                      }
                    ]
                  }
                ]
              : []
          }
        />
      </div>
    );
  }
}

PieChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  useCustomColors: PropTypes.bool.isRequired,
  showLegend: PropTypes.bool.isRequired
};

export default PieChart;
